// 旧サイト/旧アプリ由来 URL の救済リダイレクト。
// 読み込み元は sections/v2-header.liquid（v1 は sections/header.liquid）。
const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const { pathname, search } = window.location;

// 旧EC の検索URL → v2 検索。`q` は Shopify が search.terms に展開し
// sections/v2-search-main.liquid 経由で Algolia の query になる。
// `options[prefix]=last` は Shopify ネイティブ検索用で v2 では参照されないため付けない。
// ⚠️ 条件は `?name`（先頭パラメータ）のまま維持する。`&name` まで拾うと
// 下の旧ECパラメータ一式（name は4番目）がこちらに先に食われて /collections/new へ飛ばなくなる。
if (pathname === '/collections/all' && search.indexOf('?name') !== -1) {
  // entries() は decode 済みの値を返すため、そのまま埋めると & や # で URL が壊れる
  window.location.href = `/search?q=${encodeURIComponent(params?.name ?? '')}`;
}

if (pathname.includes('/user_data')) {
  window.location.href = '/';
}

if (document.URL === 'https://magazine.kuradashi.jp/') {
  window.location.href = '/blogs/kuradashi-magazine';
}

if (
  pathname === '/collections/all' &&
  params?.category_id === '' &&
  params?.disp_number === '0' &&
  params?.mode === '' &&
  params?.name === '' &&
  params?.orderby === '1' &&
  params?.pageno === '1' &&
  params?.sale_status === '1'
) {
  // v2 の並び替えは Algolia の replica index 駆動（URL は ?sort=<ラベル>）で
  // `sort_by` は参照されない。コレクション閲覧の既定が新着順
  // （snippets/v2-collection-sort-options.liquid の先頭 + kd-search-main の
  // 「コレクション閲覧は Liquid の selected option を採用」）なので、
  // ?sort= を明示せず既定に委ねる（日本語ラベルを URL に固定しない）。
  window.location.href = '/collections/new';
}
